<template>
  <div class="wrap result-wrap">
    <div class="content">
      <template v-if="type === 'loading'">
        <div class="icon loading"></div>
        <div class="text">{{ $t('loginning') }}</div>
      </template>
      <template v-else-if="type === 'success'">
        <div class="icon success"></div>
        <div class="text">{{ $t('login_success_2') }}</div>
      </template>
      <template v-else-if="type === 'fail'">
        <div class="icon fail"></div>
        <div class="text">
          {{ $t('login_fail_2') }}
          <p class="code-tips" v-if="code > 0">{{ code }} - {{ $t(`KGSDK_${code}`) }}</p>
        </div>
      </template>
    </div>
    <div v-if="type === 'fail'" class="btns">
      <Button type="warning" @click="reLogin">{{ $t('try_again') }} </Button>
    </div>
    <div v-if="type === 'success' && urlParams.source_id === $ENUM.SOURCE_ID_MAP.MICRO_TERMINAL" class="btns">
      <Button type="warning" @click="backToGame">{{ $t('continue') }} </Button>
    </div>
  </div>
</template>

<script>
import { sendLogin } from '../utils/Qtbridge'
import { socialLogin, webSocialLogin } from '@/api'
export default {
  name: 'Result',
  data () {
    const loginData = this.$route.params.loginData || {}
    return {
      type: 'loading',
      urlParams: JSON.parse(window.localStorage.getItem('sdkParams') || '{}'),
      once_key: undefined,
      loginData,
      code: undefined
    }
  },
  created () {
    this.login()
  },
  methods: {
    login () {
      const data = this.$route.params.loginData || {}
      this.$utils.log('pc_web_loging', {
        login_method: data.type + (data.mode ? `_${data.mode}` : '')
      })
      if (typeof window.qt !== 'undefined') {
        // 微端 webview 登录
        this.loginWithMicroTerminal(data)
      } else if (this.urlParams.refer) {
        // 网站登录，有 refer 需要回跳
        this.loginWithWebsite(data)
      } else if (this.urlParams.source_id === this.$ENUM.SOURCE_ID_MAP.MICRO_TERMINAL) {
        // 新版微端登录
        this.loginWithWs(data)
      }
    },
    // 网页登录
    loginWithWebsite (data) {
      const refer = decodeURIComponent(this.urlParams.refer)
      // 是否需要游戏数据 ng - need game 
      if (!this.urlParams.ng) {
        window.location.href = `${refer}${refer.indexOf('?') > 0 ? '&' : '?'}data=${
          {
            name: data.name,
            id: data.id,
            token: data.token
          }
        }`
      } else if (this.urlParams.source_id === this.$ENUM.SOURCE_ID_MAP.PC_OFFICIAL && ['30001', '30010', '30007'].includes(this.urlParams.gid.toString())) {
        // 只有当游戏是 SS(30001)且是官网登录时走游戏passport
        const params = {
          gameId: this.urlParams.gid,
          deviceId: 'fpoauth' + this.$utils.randomString(25),
          bindType: this.$ENUM.SOCIAL_CODE_MAP[data.type],
          accessToken: data.token,
          deviceUuid: this.$utils.getUuid(),
          bindInfo: {
            id: data.id,
            name: data.name,
            email: data.email || ''
          }
        }
        socialLogin(params).then(res => {
          this.type = 'success'
          window.location.href = `${refer}${refer.indexOf('?') > 0 ? '&' : '?'}${this.urlParams.ng}=${this.$utils.string10to62(res.fpid)}`
        }).catch(err => {
          this.$msg.success(this.$t(`KGSDK_${err.code}`))
          this.type = 'fail'
          this.code = err.code

          this.$gtag.event('PC_login', {
            login_game_id: this.urlParams.gid,
            login_type: 'web_login',
            login_code: err.code
          })
          console.error(JSON.stringify({
            type: 'axios',
            request: params,
            response: err
          }))
          setTimeout(() => {
            window.location.href = `${refer}`
          }, 2000);
        })
      } else {
        const params = {
          game_id: this.urlParams.gid,
          device_id: 'fpoauth' + this.$utils.randomString(25),
          device_uuid: this.$utils.getUuid(),
          device_type: 'web',
          bind_type: this.$ENUM.SOCIAL_CODE_MAP[data.type],
          access_token: data.token,
          bind_info: {
            id: String(data.id),
            name: data.name,
            email: data.email || ''
          },
          lang: this.urlParams.lang
        }
        // dw passport 流程需要用到 fp_device_id 获取 fpid list
        if (data.type === this.$ENUM.SOCIAL_MAP.FUNPLUS_ID) {
          params.fp_device_id = data.fp_device_id
        }
        webSocialLogin(params).then(res => {
          this.type = 'success'
          window.location.href = `${refer}${refer.indexOf('?') > 0 ? '&' : '?'}${this.urlParams.ng}=${encodeURIComponent(res.token)}`
        }).catch(err => {
          this.$msg.success(this.$t(`KGSDK_${err.code}`))
          this.type = 'fail'
          this.code = err.code
          this.$gtag.event('PC_login', {
            login_game_id: this.urlParams.gid,
            login_type: 'web_login',
            login_code: err.code
          })
          setTimeout(() => {
            window.location.href = `${refer}`
          }, 2000);
        })
      }
    },
    // 微端登录
    loginWithMicroTerminal (data) {
      const params = {
        ...data,
        id: data.id.toString()
      }
      sendLogin(params)
        .then(() => this.type = 'success')
        .catch(err => {
          this.type = 'fail'
          this.code = err.code
          this.$msg.success(this.$t(`KGSDK_${err.code}`))
        })
    },
    // websocket 登录
    loginWithWs (data, register = 0) {
      const userInfo = {
        ...data,
        id: data.id.toString()
      }
      this.once_key = this.$utils.getTS()
      this.$Spin.show()
      const params = {
        action: 'web_login',
        userInfo,
        once_key: this.once_key,
        fp_device_id: window.localStorage.getItem('deviceId'),
        register
      }

      // 用户点击注册上报打点
      if (register) {
        this.$utils.customLog('20016_register', params, {})
      }

      this.$socket.push({
        params,
        cb: resp => {
          // 用户点击注册成功后打点
          if (params.register && resp.code === 0) {
            this.$utils.customLog('20016_register_suc', params, resp)
          }
          this.loginHandler(resp)
        }
      })
    },
    loginHandler (resp) {
      if (resp.action !== 'web_login' && resp.once_key !== this.once_key) return
      this.$Spin.hide()
      if (resp.code === 0) {
        this.type = 'success'
      } else {
        this.type = 'fail'
        this.code = resp.code
        if (resp.code === 20016 && this.$utils.gtVersion(1)) {
          this.$dialog(
            {
              title: this.$t('web_tips_title'),
              text: this.$t('register_account_tips'),
              confirmTxt: this.$t('test_confirm'),
              cancelTxt: this.$t('test_cancel')
            },
            () => {
              this.loginWithWs(this.$route.params.loginData, 1)
            }
          )
        } else {
          this.$msg.success(this.$t(`KGSDK_${resp.code}`))
        }
        this.$gtag.event('PC_login', {
          login_game_id: this.urlParams.gid,
          login_type: 'ws_login',
          login_code: resp.code
        })
      }
    },
    reLogin () {
      this.$router.replace({ name: 'Login' })
    },
    backToGame () {
      this.$socket.push({
        params: {
          action: 'client_top',
          once_key: this.once_key
        }
      })
    }
  },
  beforeRouteEnter (to, from, next) {
    if (!from.name) {
      return next({
        path: '/login',
        replace: true
      })
    }
    next()
  }
}
</script>

<style lang='less' scoped >
.r-success {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  .icon {
    width: 51px;
    height: 51px;
    background: url(~@img/icon_success.png) center center no-repeat;
    background-size: 100% 100%;
  }
  .text {
    color: #111111;
    font-size: 18px;
    line-height: 18px;
    margin-top: 19px;
  }
}
.wrap {
  height: 100%;
  padding: 0 32px 20px;
  display: flex;
  flex-direction: column;
  .content {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .icon {
    width: 51px;
    height: 51px;
    background: url(~@img/icon_fail.png) center center no-repeat;
    background-size: 100% 100%;
    &.success { background-image: url(~@img/icon_success.png); }
    &.fail { background-image: url(~@img/icon_fail.png); }
    &.loading {
      background-image: url(~@img/icon_loading.png);
      filter: contrast(0.5);
      animation: infiniteRotate linear 2s infinite;
    }
  }
  .text {
    color: #111111;
    font-size: 18px;
    line-height: 18px;
    margin-top: 19px;
    text-align: center;
  }
  .code-tips {
    margin-top: 10px;
    font-size: 12px;
    line-height: 1.5;
    color: #777;
  }
}
@keyframes infiniteRotate {
  0% {
    transform: rotate(0);
  }
  50% {
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
